import { client } from "./client";
import interceptors from "./interceptors";
import qs from 'qs';

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getSR(params) {
	return client.get("api/sr/data", {
		params: params,
	});
}

function getSRAll(params) {
	return client.get("api/sr/all", {
		params: params,
	});
}

function exportSR(params) {
	return client.get("api/sr/export", {
		params: params,
	});
}

function exportSRAll(params) {
	return client.get("api/sr/export-all", {
		params: params,
	});
}

function getDetailSR(params) {
	return client.get("api/sr/detail", {
		params: {
			sr_code : params
		},
	});
}

function createSR(params) {
	return client.post("api/sr/create", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	})
}

function scanSerial(params) {
	return client.post("api/sr/scan", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	})
}

function sendEmailSerial(params) {
	return client.post("api/sr/resend-email-serial", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	})
}

export default {
	getSR,
	getSRAll,
	exportSR,
	exportSRAll,
	getDetailSR,
	createSR,
	scanSerial,
	sendEmailSerial,
};